import {AxiosError} from 'axios';
import {CreditBookApi} from '../ApiService';
import {logout} from './logout';
import {
  setSessionStorage,
  sessionStorageDictionary,
} from '../../../sessionStorage';

/**
 * Set error handler for 401 Unauthorized errors
 */
function setUnauthorizedErrorHandler() {
  CreditBookApi.setErrorHandler(async (error: AxiosError) => {
    const is401Error = error.response?.status === 401;
    if (is401Error) {
      await logout();
    }
  });
}

/**
 * Login with OTP
 */
async function otpLogin(username: string, otp: string) {
  const validate = await CreditBookApi.auth.validateOtp(username, otp);

  if (validate.data.token) {
    // Set the error handler for unauthorized errors
    setUnauthorizedErrorHandler();

    // Store the token in the API service
    CreditBookApi.setToken(validate.data.token);

    // Handle multipleMatch flag - store in session storage if true
    if (validate.data.multipleMatch) {
      setSessionStorage(
        sessionStorageDictionary.WARNING_BANNER_DISMISSED,
        'false',
      );
    }
  }
}

// If already authenticated, set the error handler
if (CreditBookApi.tokenManager.isAuthenticated()) {
  setUnauthorizedErrorHandler();
}

export {otpLogin};
